import { type FC } from 'react';
import CcmDashboardFilterPopover from 'components/molecules/oneplaform/ccm-dashboard-filter-popover';

import s from './styles.module.scss';

import type { TCCMDataFilters } from 'infrastructure/hooks/ccm/console/use-ccm-data-query-filter';

interface AccountSelectBoxProps {
  updateFilter: (newFilter: Partial<TCCMDataFilters>) => void;
  clinicGuid?: string[];
}

const TABLE_PREFIXES = ['n-', 'f-', 'p-'] as const;

export const AccountsSelect: FC<AccountSelectBoxProps> = ({
  clinicGuid,
  updateFilter,
}) => {
  return (
    <div className={s['select-wrapper-accounts']}>
      <div className={s['select-label']}>
        <CcmDashboardFilterPopover
          useAdminApi
          showOnInteractiveTimeDashboard={false}
          included={clinicGuid}
          onChange={({ included = [] }) => {
            const patch: Record<string, any> = {};
            TABLE_PREFIXES.forEach((p) => {
              patch[`${p}clinicGuid`] = included;
              patch[`${p}allExcluded`] = false;
              patch[`${p}page`] = undefined;
            });
            updateFilter(patch);
          }}
        />
      </div>
    </div>
  );
};
